import React from 'react';
import { X, XCircle } from 'lucide-react';
import './SupplierQuoteSubmitModal.css';

export type SupplierNotBiddingModalMode = 'confirm' | 'remove';

export type SupplierNotBiddingModalProps = {
  open: boolean;
  mode: SupplierNotBiddingModalMode;
  busy?: boolean;
  onClose: () => void;
  onConfirm: () => void | Promise<void>;
};

const SupplierNotBiddingModal: React.FC<SupplierNotBiddingModalProps> = ({
  open,
  mode,
  busy = false,
  onClose,
  onConfirm,
}) => {
  if (!open) return null;

  const isConfirm = mode === 'confirm';
  const title = isConfirm ? 'Mark as not bidding?' : 'Remove not bidding?';
  const body = isConfirm
    ? 'LC Timber Frames will be notified that your organization will not submit a quote for this package version. You can remove this response later if your plans change.'
    : 'Remove your not bidding response so you can upload a quote for this package version. LC Timber Frames will see that you have not yet responded.';

  return (
    <div className="sqs-modal-backdrop" role="presentation" onClick={busy ? undefined : onClose}>
      <div
        className="sqs-modal"
        role="dialog"
        aria-modal="true"
        aria-labelledby="snb-modal-title"
        onClick={e => e.stopPropagation()}
      >
        <header className="sqs-modal-head">
          <h2 id="snb-modal-title">{title}</h2>
          <button
            type="button"
            className="sqs-modal-close"
            onClick={onClose}
            disabled={busy}
            aria-label="Close"
          >
            <X size={16} />
          </button>
        </header>
        <div className="sqs-modal-body">
          <p className="sqs-modal-message">{body}</p>
          <div className="sqs-modal-actions">
            <button type="button" className="vp-btn" disabled={busy} onClick={onClose}>
              Cancel
            </button>
            <button
              type="button"
              className={`vp-btn${isConfirm ? ' vp-btn-muted' : ' vp-btn-danger'}`}
              disabled={busy}
              onClick={() => void onConfirm()}
            >
              {isConfirm ? (
                <>
                  <XCircle size={16} aria-hidden /> {busy ? 'Saving…' : 'Mark not bidding'}
                </>
              ) : (
                busy ? 'Removing…' : 'Remove not bidding'
              )}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SupplierNotBiddingModal;
